import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';

export type ToggleAction = 'enable' | 'disable';

interface WatchlistPaymentRemarksEnable {
  action: 'enable';
  watchlistUuid: string;
}

interface WatchlistPaymentRemarksDisable {
  action: 'disable';
  sensitiveDataWatchlistAccessUuid: string;
}

interface CompanyPaymentRemarksEnable {
  action: 'enable';
  companyUuid: string;
}

interface CompanyPaymentRemarksDisable {
  action: 'disable';
  sensitiveDataCompanyAccessUuid: string;
}

export type TogglePaymentRemarksModalProps =
  | WatchlistPaymentRemarksEnable
  | WatchlistPaymentRemarksDisable
  | CompanyPaymentRemarksEnable
  | CompanyPaymentRemarksDisable;

export function getTogglePaymentRemarksModalProps(
  action: TogglePaymentRemarksModalProps['action'],
  type: 'watchlist' | 'company',
  uuid: string,
): TogglePaymentRemarksModalProps {
  if (!(action && type && uuid)) {
    throw new Error('getTogglePaymentRemarksModalProps: wrong input params were provided.');
  }
  if (action === 'enable') {
    if (type === 'watchlist') {
      return { action: 'enable', watchlistUuid: uuid };
    }
    return { action: 'enable', companyUuid: uuid };
  }
  if (type === 'watchlist') {
    return { action: 'disable', sensitiveDataWatchlistAccessUuid: uuid };
  }
  return { action: 'disable', sensitiveDataCompanyAccessUuid: uuid };
}

const PAYMENT_REMARKS_TOASTR_MESSAGES = {
  watchlistToggleSuccess: extractTranslation(
    'watchlists.details_view.management_card.watchlist_update.success_message',
  ),
  watchlistToggleError: extractTranslation('watchlists.details_view.management_card.watchlist_update.error_message'),
  companyToggleSuccess: extractTranslation(
    'company.event_feed.options.payment_remarks.payment_remarks_toggle.success_message',
  ),
  companyToggleError: extractTranslation(
    'company.event_feed.options.payment_remarks.payment_remarks_toggle.error_message',
  ),
};

export function getToggleMessage(actionType: 'success' | 'error', entityType: 'watchlist' | 'company'): string {
  if (!actionType || !entityType) {
    return '';
  }
  if (actionType === 'success') {
    return entityType === 'watchlist'
      ? PAYMENT_REMARKS_TOASTR_MESSAGES.watchlistToggleSuccess
      : PAYMENT_REMARKS_TOASTR_MESSAGES.companyToggleSuccess;
  }
  return entityType === 'watchlist'
    ? PAYMENT_REMARKS_TOASTR_MESSAGES.watchlistToggleError
    : PAYMENT_REMARKS_TOASTR_MESSAGES.companyToggleError;
}
